import { Component } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/auth/services/auth.service';
import {
  SIDEBAR_ITEMS_ADMIN,
  SIDEBAR_ITEMS_EMPLOYEE,
  SIDEBAR_ITEMS_SUPER_ADMIN,
} from './sidebar-items';
import { filter } from 'rxjs';
import { UserProfile, UserRole } from '../../../core/auth/services/token';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  imports: [MaterialModule, RouterModule, CommonModule],
  templateUrl: './sidebar.html',
  styleUrls: ['./sidebar.scss'],
})
export class Sidebar {
  sidebarItems: SidebarItem[] = [];
  expandedItems: Set<string> = new Set();
  currentUrl: string = '';

  constructor(public auth: AuthService, private router: Router) {
    this.currentUrl = this.router.url;
    this.setSidebarItems();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrl = event.urlAfterRedirects;
        this.setSidebarItems();
      });
  }

  private setSidebarItems() {
    const profile: UserProfile | null = this.auth.profile;
    let items: SidebarItem[] = [];

    switch (profile) {
      case 'SALARIE':
        items = SIDEBAR_ITEMS_EMPLOYEE;
        break;
      case 'ADMIN_ENTREPRISE':
        items = SIDEBAR_ITEMS_ADMIN;
        break;
      case 'SUPER_ADMIN':
        items = SIDEBAR_ITEMS_SUPER_ADMIN;
        break;
      default:
        items = [];
    }

    const roles = this.auth.roles;
    this.sidebarItems = items.filter((item) => {
      if (!item.roles) return true;
      return item.roles.some((role: UserRole) => roles.includes(role));
    });
  }

  hasChildren(item: SidebarItem): boolean {
    return !!(item.children && item.children.length > 0);
  }

  isExpanded(item: SidebarItem): boolean {
    return this.expandedItems.has(item.label);
  }

  toggleExpand(item: SidebarItem): void {
    if (this.expandedItems.has(item.label)) {
      this.expandedItems.delete(item.label);
    } else {
      this.expandedItems.add(item.label);
    }
  }

  /**
   * Exact match only — strips query params/fragments, then compares strictly.
   * Exactly one item will be highlighted at a time.
   */
  isActive(route: string): boolean {
    const cleanUrl = this.currentUrl.split('?')[0].split('#')[0];
    return cleanUrl === route;
  }

  logOut() {
    this.auth.logout();
  }
}

// ----- Type definitions (move to sidebar-items.ts if preferred) -----

export interface SidebarItem {
  label: string;
  route: string;
  icon: string;
  roles?: UserRole[];
  children?: SidebarItem[];
}